import {writable} from "svelte/store";
import {todos, eliminar} from '../Api/usuarios';

const estadoInicial = {
  cargando: false,
  error: null,
  listado: [],
  listadoIndexado: {},
  usuarioEliminando: null,
  errorEliminacion: null
};

const store = writable(estadoInicial);

export default {
  subscribe: store.subscribe,
  cargar: () => {
    const timeout = setTimeout(() => store.update(valor => ({...valor, cargando: true})), 100);

    store.update(() => estadoInicial);

    todos()
        .then(listado => store.update(valor => ({
          ...valor,
          listado: listado,
          listadoIndexado: listado.reduce((acc, x) => ({[x.id]: x, ...acc}), {}),
          error: false
        })))
        .catch(e => store.update(valor => ({...valor, error: e})))
        .finally(() => {
          clearTimeout(timeout);
          store.update(valor => ({...valor, cargando: false}));
        });
  },
  eliminarUsuario(usuario) {
    store.update(estado => ({
      ...estado,
      usuarioEliminando: usuario,
      errorEliminacion: null
    }));
  },
  eliminaUsuarioDeVerdad(usuario) {
    eliminar(usuario).then(() => {
      store.update(x => ({...x, errorEliminacion: null, usuarioEliminando: null}));
      this.cargar();
    }).catch(e => store.update(x => ({...x, errorEliminacion: e.response.data})));
  }
};